// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cc-tooltip[data-v-0a656fc8] {\n  background: var(--v-panel-darken1) !important;\n  background-color: var(--v-panel-darken1) !important;\n  opacity: 1 !important;\n  max-width: 50vw;\n  border: 1px var(--v-active-base) solid;\n}\n.fade-enter-active[data-v-0a656fc8],\n.fade-leave-active[data-v-0a656fc8] {\n  transition: opacity 0.5s;\n}\n.fade-enter[data-v-0a656fc8],\n.fade-leave-to[data-v-0a656fc8] {\n  opacity: 0;\n}\n", ""]);
// Exports
module.exports = exports;
